(function ($) {

    /*------------------------------------*\
        DEVHUB CPT LIGHTBOX
        Two modes: image (default) and iframe.

        Triggers:
          .devhub-lightbox-trigger    → image mode; reads data-src (or href).
          .js-tf-expand-mockup        → iframe mode; reads data-src for the
                                        raw mockup URL (?raw=1). Used on hub
                                        mockup cards to preview a full-size
                                        render without leaving the hub.

        Container is .js-lightbox; close on overlay click, close button, or
        Escape. Elements are looked up at click time (not cached at bind
        time) so the plugin survives shell-nav content-pane swaps that
        replace the overlay markup.
    \*------------------------------------*/

    $.fn.devhubCptLightbox = function () {

        function open(src, mode) {

            var $lightbox = $('.js-lightbox');
            if (!$lightbox.length) { return; }

            var $img    = $lightbox.find('.js-lightbox-img');
            var $iframe = $lightbox.find('.js-lightbox-iframe');

            if ('iframe' === mode) {
                $img.hide().attr('src', '');
                $iframe.show().attr('src', src);
            } else {
                $iframe.hide().attr('src', '');
                $img.show().attr('src', src);
            }

            $lightbox.addClass('active');

        }

        function close() {

            var $lightbox = $('.js-lightbox');
            if (!$lightbox.length) { return; }

            $lightbox.removeClass('active');
            $lightbox.find('.js-lightbox-img').attr('src', '');
            $lightbox.find('.js-lightbox-iframe').attr('src', '');

        }

        // Image mode — the existing trigger (used on image-only designs +
        // Consolidator shot-links).
        $(document).on('click', '.devhub-lightbox-trigger', function (e) {

            e.preventDefault();

            var src = $(this).data('src') || $(this).attr('href');

            if (src) {
                open(src, 'image');
            }

        });

        // Iframe mode — the new hub mockup Expand button. Stop propagation
        // so the click doesn't bubble to the parent card's shell-nav anchor
        // (the tool button lives outside the anchor but Safari-family
        // browsers sometimes still coalesce nested-click intent).
        $(document).on('click', '.js-tf-expand-mockup', function (e) {

            e.preventDefault();
            e.stopPropagation();

            var src = $(this).data('src');

            if (src) {
                open(src, 'iframe');
            }

        });

        $(document).on('click', '.js-lightbox-close', function () {

            close();

        });

        $(document).on('keydown', function (e) {

            if ('Escape' === e.key && $('.js-lightbox').hasClass('active')) {
                close();
            }

        });

        return this;

    };

}(jQuery));
